export class FooterStickyAd {

    static init() {
        var $ = jQuery;
        //
        var threshold = 700;
        var showed = false;
        //
        // Show hide by scroll
        $(window).scroll(function () {
            var scrollTop = $(this).scrollTop();

            if (!showed && scrollTop > threshold) {
                showed = true;
                $('.js-footer-sticky-ad').addClass('show');
            }
        });

        $(document.body).on('click', '.js-footer-sticky-ad-close', function() {
            $('.js-footer-sticky-ad').removeClass('show');
        });
    }
}